// src/components/table/columnsConfig/strategyRegions.js
import { Box, FormControl, Select, MenuItem } from "@mui/material";

export const getStrategyRegionsColumns = (
  theme,
  {
    editingStrategy,
    selectedRegion,
    strategyAllowedRegionsData,
    onStartEdit,
    onCancelEdit,
    onUpdateRegion,
    onDeleteClick,
    onRegionChange,
  }
) => [
  {
    header: "Strategy Name",
    accessorKey: "StrategyName",
    size: 200,
    enableSorting: true,
    enableColumnFilter: false,
  },
  {
    header: "Region",
    accessorKey: "Region",
    size: 200,
    enableSorting: true,
    enableColumnFilter: false,
    Cell: ({ row }) => {
      const strategyName = row.original.StrategyName;
      const currentRegion = row.original.Region;
      const isEditing = editingStrategy === strategyName;

      if (isEditing) {
        return (
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <Select
              value={selectedRegion}
              onChange={(e) => onRegionChange(e.target.value)}
              displayEmpty
              size="small"
            >
              <MenuItem value="">
                <em>Select Region</em>
              </MenuItem>
              {strategyAllowedRegionsData &&
              strategyAllowedRegionsData.length > 0 ? (
                strategyAllowedRegionsData.map((region) => (
                  <MenuItem key={region.id} value={region.region}>
                    {region.region}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>
                  <em>No regions available</em>
                </MenuItem>
              )}
            </Select>
          </FormControl>
        );
      }

      return <span>{currentRegion || "No Region"}</span>;
    },
  },
  {
    header: "Actions",
    accessorKey: "actions",
    size: 200,
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ row }) => {
      const strategyName = row.original.StrategyName;
      const currentRegion = row.original.Region;
      const isEditing = editingStrategy === strategyName;

      if (isEditing) {
        return (
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <button
              onClick={() => onUpdateRegion(strategyName, selectedRegion)}
              disabled={!selectedRegion}
              style={{
                padding: "4px 8px",
                fontSize: "12px",
                backgroundColor: theme.palette.primary.main,
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: selectedRegion ? "pointer" : "not-allowed",
                opacity: selectedRegion ? 1 : 0.6,
              }}
            >
              Update
            </button>
            <button
              onClick={() => onCancelEdit()}
              style={{
                padding: "4px 8px",
                fontSize: "12px",
                backgroundColor: theme.palette.grey[500],
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </Box>
        );
      }

      return (
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <button
            onClick={() => onStartEdit(strategyName, currentRegion)}
            style={{
              padding: "6px 12px",
              fontSize: "12px",
              backgroundColor: theme.palette.secondary.main,
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Edit
          </button>
          <button
            onClick={() => onDeleteClick(strategyName, row.original.id)}
            style={{
              padding: "6px 12px",
              fontSize: "12px",
              backgroundColor: theme.palette.error.main,
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Delete
          </button>
        </Box>
      );
    },
  },
];

export const getMissingRegionsColumns = (
  theme,
  {
    editingStrategy,
    selectedRegion,
    strategyAllowedRegionsData,
    onStartEdit,
    onCancelEdit,
    onAddRegion,
    onRegionChange,
  }
) => [
  {
    header: "Strategy Name",
    accessorKey: "StrategyName",
    size: 300,
    enableSorting: true,
    enableColumnFilter: false,
  },
  {
    header: "Add Region",
    accessorKey: "addRegion",
    size: 400,
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ row }) => {
      const strategyName = row.original.StrategyName;
      const isEditing = editingStrategy === strategyName;

      if (isEditing) {
        return (
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <Select
                value={selectedRegion}
                onChange={(e) => onRegionChange(e.target.value)}
                displayEmpty
                size="small"
              >
                <MenuItem value="">
                  <em>Select Region</em>
                </MenuItem>
                {strategyAllowedRegionsData &&
                strategyAllowedRegionsData.length > 0 ? (
                  strategyAllowedRegionsData.map((region) => (
                    <MenuItem key={region.id} value={region.region}>
                      {region.region}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="" disabled>
                    <em>No regions available</em>
                  </MenuItem>
                )}
              </Select>
            </FormControl>
            <Box sx={{ display: "flex", gap: 0.5 }}>
              <button
                onClick={() => onAddRegion(strategyName, selectedRegion)}
                disabled={!selectedRegion}
                style={{
                  padding: "4px 8px",
                  fontSize: "12px",
                  backgroundColor: theme.palette.primary.main,
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: selectedRegion ? "pointer" : "not-allowed",
                  opacity: selectedRegion ? 1 : 0.6,
                }}
              >
                Add
              </button>
              <button
                onClick={() => onCancelEdit()}
                style={{
                  padding: "4px 8px",
                  fontSize: "12px",
                  backgroundColor: theme.palette.grey[500],
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </Box>
          </Box>
        );
      }

      return (
        <button
          onClick={() => onStartEdit(strategyName)}
          style={{
            padding: "6px 12px",
            fontSize: "12px",
            backgroundColor: theme.palette.secondary.main,
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Add Region
        </button>
      );
    },
  },
];
